import React from 'react';
// import { useAppSelector } from '../../redux/store';
type Props = {
  summaryExists: boolean;
  isPending: boolean;
  isEnabled: boolean;
  summaryInProgress: boolean;
  onSummarize: () => void;
  onExport: () => void;
};

export const SummaryButtonGroup = ({
  summaryExists,
  isPending,
  isEnabled,
  summaryInProgress,
  onSummarize,
  onExport,
}: Props) => {
  // const { sessionLockKey } = useAppSelector((state) => state.app.editorLock);

  return (
    <div className="summary_modal_button_group">
      <button
        onClick={() => onSummarize()}
        className="button_primary"
        disabled={!isEnabled || isPending || summaryInProgress}
      >
        {summaryInProgress && 'Povzemanje v teku...'}
        {!summaryInProgress && isPending && 'Nalagam...'}
        {!summaryInProgress && !isPending && 'Povzemi'}
      </button>
      {summaryExists && (
        <button className="button_secondary" onClick={() => onExport()}>
          Izvozi
        </button>
      )}
    </div>
  );
};
